import { render, staticRenderFns } from "./create-education.vue?vue&type=template&id=4cc54b19&"
import script from "./create-education.vue?vue&type=script&lang=js&"
export * from "./create-education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports